export function mapLSportsStateToProps(state, props) {
    return state;
}
